import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="sales-update-exchange-rate"
export default class extends Controller {
  static values = { url: String }

  static get targets() {
    return ["rate", "loader"]
  }

  connect() {
  }

  submit() {
    const rateValue = this.rateTarget.value
    
    this.loaderTarget.innerHTML = 'updating...';

    fetch(
      `${this.urlValue}.json`,
      {
        body: JSON.stringify({ exchange_rate: rateValue }),
        method: 'PATCH',
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.head.querySelector("meta[name=csrf-token]")?.content
        }
      }
    )
    .then((response) => {
      if (!response.ok) {
        throw new Error('Network error');
      }

      return response.text();
    })
    .then(res => {
      this.loaderTarget.innerHTML = '';
    })
    .catch(error => {
      this.loaderTarget.innerHTML = 'failed';
    })
  }
}
